export const heatmapCustomEvents = {
  START_SEARCH: 'heatmap-search'
};
